/* eslint-disable id-length */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as Plot from '@observablehq/plot';
import * as d3 from 'd3';
import { useEffect, useRef } from 'react';

import './index.css';

export interface IBarChartProps {
    id: string;
    width: number;
    height: number;
    data: Array<{
        name: string;
        value: number;
    }>;
}

type GraphRecord = {
    name: string;
    value: number;
    subValue: number;
};

export const BarChart = ({ id, width, height, data }: IBarChartProps) => {
    const ref = useRef<HTMLDivElement>(null);

    const color = d3.scaleOrdinal(
        [
            '#1ad079',
            '#19c576',
            '#18b972',
            '#16a16a',
            '#148a62',
            '#11725a',
            '#0f5b53',
            '#0c434b',
            '#0a2b43',
            '#07133b',
        ].reverse()
    );

    useEffect(() => {
        let stack = 0;
        const graphData: GraphRecord[] = data.map((record) => {
            stack += record.value;
            return {
                name: record.name,
                value: stack,
                subValue: record.value,
            };
        });

        const chart = Plot.plot({
            width,
            height,
            y: {
                grid: true,
                label: 'Leads',
                ticks: 5,
            },
            x: {
                label: 'Miles',
            },
            marks: [
                Plot.ruleY([0]),
                // new Plot.BarY(graphData, {
                // cai_barY(graphData, {
                Plot.barY(graphData, {
                    x: 'name',
                    y: 'value',
                    sort: { x: 'y' },
                    strokeWidth: 30,
                    width: 30,
                    title: (_: GraphRecord) =>
                        `Leads: ${_.subValue}\nTotal Leads: ${_.value}\n`,
                    fill: (_: GraphRecord, i: number) => color(i.toString()),
                }),
                Plot.text(graphData, {
                    x: 'name',
                    y: 'value',
                    sort: { x: 'y' },
                    text: 'value',
                    dy: -6,
                }),
                Plot.text(graphData, {
                    x: 'name',
                    y: 'value',
                    sort: { x: 'y' },
                    text: (datum: GraphRecord) => `+${datum.subValue}`,
                    fill: 'white',
                    dy: 8,
                    dx: -3,
                }),
            ],
        });

        if (ref?.current) ref.current.append(chart);

        return () => chart.remove();
    });

    // eslint-disable-next-line react/forbid-dom-props
    return <div id={id} ref={ref} className="bar-chart" />;
};
